export default ({ address1, address2, city, state, zipCode, zipcode }) =>
  `${address1}<br />${address2 ? `${address2}<br />` : ''}${city ? `${city}, ` : ''}${state}${
    zipCode || zipcode ? ` ${zipCode || zipcode}` : ''
  }`;
